module.exports = __webpack_public_path__ + "img/ico-13-active.be9e7e01.svg";